import { render } from "./ConnectFlowModelingPage.vue?vue&type=template&id=bc2533b2&ts=true"
import script from "./ConnectFlowModelingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectFlowModelingPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/ConnectFlowModelingPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc2533b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc2533b2', __exports__)) {
    api.reload('bc2533b2', __exports__)
  }
  
  module.hot.accept("./ConnectFlowModelingPage.vue?vue&type=template&id=bc2533b2&ts=true", () => {
    api.rerender('bc2533b2', render)
  })

}


export default __exports__